import React, { PropTypes } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { factoryCmsContent } from '../../../api/club-cms/content';
import { PlayerListContent } from '../../../api/club-cms/content/player-list.content';
import { CMSContentType } from '../../../api/club-cms/CMSType';
import { ListContentComponent } from './ListContentComponent/ListContentComponent';
import { ImageListContentComponent } from './ImageListContentComponent';
import { DetailsEdit } from './ListContentComponent/DetailsEdit';
import PlayerListContentComponent from './PlayerListContent';
import TwoColumnsContentComponent from './TwoColumnContent';
import HeaderTwoContent from '../../../api/club-cms/headers/header-two.content';

class Content extends React.Component {
  static propTypes = {
    movable: PropTypes.bool.isRequired,
    disableMovable: PropTypes.func.isRequired,
    node: PropTypes.object,
    updateHeaderOneLabel: PropTypes.func.isRequired,
    removeHeaderOne: PropTypes.func.isRequired,
    moveItem: PropTypes.func.isRequired
  };

  static defaultProps = {
    disableMovable: () => {},
    movable: false
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  state = {
    open: true
  };

  _toggleCollapse = () => {
    let { disableMovable, movable } = this.props;
    if (movable) {
      disableMovable();
      this.setState({ open: true });
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  /**
   *
   * @param {HeaderOneContent} headerOn0e
   * @param {AContent} ContentClass
   * @private
   */
  _checkPlayerClass(headerOne, ContentClass) {
    return headerOne.children
      .map(content => content instanceof ContentClass)
      .includes(true);
  }

  updateListContent(item, newItem) {
    const { node, onChange } = this.props;
    onChange(node.updateListItem(item, newItem));
  }

  addListContent(type) {
    const { node, onChange } = this.props;
    onChange(node.push(factoryCmsContent(type)));
  }

  addHeaderTwoContent(type) {
    const { node, onChange } = this.props;
    onChange(node.push(
      factoryCmsContent(CMSContentType.headerTwo)
        .addChild(factoryCmsContent(type))
      )
    );
  }

  render() {
    let { node } = this.props;
    return (
      <div>
        {node && node.items && node.items.size > 0
          ? this.renderContent()
          : this.renderEmptyState()}
      </div>
    );
  }

  renderContent() {
    let { node, ...other } = this.props;
    const firstChild = node.children.first();
    if (firstChild instanceof HeaderTwoContent) {
      if (firstChild.children.first() instanceof PlayerListContent) {
        return (
          <PlayerListContentComponent
            node={node}
            addHeaderTwo={type => { this.addHeaderTwoContent(type) }}
            {...other}
        />
        );
      }
      return (
        <TwoColumnsContentComponent
          node={node}
          addHeaderTwo={type => { this.addHeaderTwoContent(type) }}
          {...other}
        />
      )
    }
    return <div>{node.children.map((item, index) => this.renderItem(item, index))}</div>
  }

  renderEmptyState() {
    return (
      <div style={{marginLeft: 30}}>
        <RaisedButton
          label="Add cards list"
          secondary={true}
          style={{ marginRight: 30 }}
          onClick={() => this.addListContent(CMSContentType.imageList)}
        />
        <RaisedButton
          label="Add persons list"
          secondary={true}
          style={{ marginRight: 30 }}
          onClick={() => this.addListContent(CMSContentType.list)}
        />
        {/* <RaisedButton
          label="Add transfers"
          secondary={true}
          style={{ marginRight: 30 }}
          onClick={() => this.addHeaderTwoContent(CMSContentType.transfers)}
        /> */}
        <RaisedButton
          label="Add players list"
          secondary={true}
          style={{ marginRight: 30 }}
          onClick={() => this.addHeaderTwoContent(CMSContentType.playerList)}
        />
        <RaisedButton
          label="Add another"
          secondary={true}
          onClick={() => this.addListContent(CMSContentType.details)}
        />
      </div>
    );
  }

  renderItem(item, index) {
    const props = {
      key: index,
      node: item,
      onChange: newItem => this.updateListContent(item, newItem)
    };

    switch (item.type) {
      case CMSContentType.details:
        return (
            <DetailsEdit key={index} style={{ width: 540, padding: '0 30px' }} value={props.node} onChange={props.onChange} />
        );
      case CMSContentType.list:
        return <ListContentComponent key={index} {...props} />;
      case CMSContentType.imageList:
        return (
          <div key={index} style={{ width: 540, padding: '0 30px' }}>
            <ImageListContentComponent {...props} />
          </div>
        );
      default:
        return <div key={index}>No content type implemented :(</div>;
    }
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/index.js